// extracted by mini-css-extract-plugin
export default {"maskForm":"MaskOverlay_maskForm__6fGxX","tabsWrapper":"MaskOverlay_tabsWrapper__6s9Mf","fullHeightPanel":"MaskOverlay_fullHeightPanel__6XHNg"};